import { ILatLng } from "../map/coords";
import { ILocationContainer } from "./backend-location";

export interface IAppLocation {
  loc: ILocationContainer;
  prevLoc?: ILocationContainer;
  flag: number;
  dispDone: boolean;
  inProgress?: boolean;
  fakeLocation?: ILatLng;
  location?: ILatLng;
  photoValidated?: boolean;
}

export enum ELocationFlag {
  RANDOM = 0,
  FIXED = 1,
  SAVED = 2,
  SAVED_LOCAL = 3
}

export enum ELocationSpecialId {
  placeholder = -1,
  virtual = -2,
  uncharted = -3
};